import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../redux/store';
import { setCredentials, logOut } from '../redux/features/auth/authSlice';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.token
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        return headers
    }
})

// The function that handles re-authentication and retrying failed requests
const baseQueryWithReauth = async (
    args: any, // The query arguments (type as needed, typically string | RequestInit)
    api: any,  // API context, which is a type provided by RTK Query
    extraOptions: any // Extra options for the base query (typically an empty object)
) => {
    // Make the original API request
    let result = await baseQuery(args, api, extraOptions);

    // Check if the request returned a 403 error (i.e., unauthorized)
    if (result?.error?.status === 403) {
        console.log('Sending refresh token to get a new access token');

        // Send the refresh token request to get a new access token
        const refreshResult = await baseQuery('/refresh', api, extraOptions);
        console.log(refreshResult);

        // If the refresh was successful, retry the original request
        if (refreshResult?.data) {
            const user = api.getState().auth.user;  // Get the user from the state
            api.dispatch(setCredentials({
                //...refreshResult.data, 
                user,
                accessToken: ''
            })); // Store the new token and user

            // Retry the original request with the new access token
            result = await baseQuery(args, api, extraOptions);
        } else {
            // If refresh fails, log the user out
            api.dispatch(logOut());
        }
    }

    return result; // Return the result (or the refreshed result if re-authentication was successful)
};


export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})

/* export const apiSlice = createApi({
  reducerPath: 'apiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://your-api-url.com/api/',
    prepareHeaders: (headers, { getState }) => {
      const { accessToken } = (getState() as RootState).auth;
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Commonly used endpoints for authentication or any other global API calls
    login: builder.mutation<{ accessToken: string; refreshToken: string }, { email: string; password: string }>({
      query: (credentials) => ({
        url: 'auth/login',
        method: 'POST',
        body: credentials,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(setAccessToken(data.accessToken));
      },
    }),
    refreshToken: builder.mutation<string, void>({
      query: () => ({
        url: 'auth/refresh-token',
        method: 'POST',
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(setAccessToken(data));
      },
    }),
  }),
});

export const { useLoginMutation, useRefreshTokenMutation } = apiSlice; */